import { apiConstants } from '../../apiConstant'
import { serviceCall } from '../../serviceCall'

export const checkPromoCode = (data, callback, errorCallBack) => {
    return async (dispatch) => {
        serviceCall({
            url: apiConstants.PAYMENT_GATEWAY.CHECK_PROMO_CODE,
            method: 'get',
            data: data,
        })
            .then((response) => {
                callback && callback(response)
            })
            .catch((error) => {
                errorCallBack && errorCallBack(error.response)
            })
    }
} 